import { CircleBtnStyle } from "./style"

type Props = {
  color: string;
  onClick?: () => void;
  selected?: boolean;
}

export const CircleButton = ({ color, onClick, selected=false }: Props) => {
  console.log(color)
  return (
    <>
      <CircleBtnStyle type="button" $color={color} onClick={onClick} $selected={selected} />                  
    </>
  )
}